import React, { useState, forwardRef } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Container, ButtonGroup } from 'react-bootstrap';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import MenuAdministrativos from './MenuAdministrativos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';
import { FaCalendar, FaList, FaSearch } from 'react-icons/fa';
import Papa from 'papaparse';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input
            value={value}
            readOnly
            className='widthCalendar'
            data-tooltip-id='tooltiparriba'
            data-tooltip-content="Seleccionte fecha"
            tabIndex={-1}
            style={{ border: 'none', background: 'transparent', pointerEvents: 'none', width: 'auto' }}
        />
        <FaCalendar/>
    </button>
));


export default function InformeFamilias(){
    const { token } = useAuth();
    const navigate = useNavigate();
    const fecha = new Date();
    const [Cargando, setCargando] = useState(false);
    const [datoscabeza, setDatoscabeza] = useState([]);
    const { control, handleSubmit, watch, formState: { errors }} = useForm({
        defaultValues: { 
            FechaInicial: fecha, 
            FechaFinal: fecha
        }
    });
    const [swalProps, setSwalProps] = useState();
    
    const onSubmit = (data) => {
        fetchData(
            data.FechaInicial.toLocaleDateString('en-CA'), 
            data.FechaFinal.toLocaleDateString('en-CA')
        );
    };
    const fetchData = async (FechaI, FechaF) => {
        const url = `/caracterizacion/informes/familias?FechaInicio=${FechaI}&FechaFinal=${FechaF}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatoscabeza(result);
        } catch (error) {
            if (error.response && error.response.status === 409) {
                setSwalProps({
                    show: true,
                    title: 'Advertencia',
                    text: error.response.data.message || 'No se encontraron registros para las fechas seleccionadas.',
                    icon: 'warning',
                });
            } else {
                setSwalProps({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la informaci&oacute;n de personas.',
                    showConfirmButton: true,
                });
            }
        } finally {
            setCargando(false);
        }
        
        
    };
    function verAtenciones(row, verAtencionesPersona) {
        return (
            <div>
                <button type="button" onClick={() => verAtencionesPersona(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver atenciones de la persona">
                    <FaList/>
                </button>
                
            </div>
        );
    }
       
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const [filters, setFilters] = useState({
        par_parentesco: '',
        dis_discapacidad: '',
        per_sexo: '',
        per_gestante: '',
        min_minoria: '',
        per_terminal: '',
        per_resguardo: '',
        per_concomunitario: '',
        bar_barrio: '',
        bar_zona: '',
        bar_comuna: '',
        creadopor: ''
    });

    // Filtrado de datos
    const filteredData = datoscabeza.filter(row =>
        (!filters.par_parentesco || row.par_parentesco === filters.par_parentesco) &&
        (!filters.dis_discapacidad || row.dis_discapacidad === filters.dis_discapacidad) &&
        (!filters.per_sexo || row.per_sexo === filters.per_sexo) &&
        (!filters.per_gestante || row.per_gestante === filters.per_gestante) &&
        (!filters.min_minoria || row.min_minoria === filters.min_minoria) &&
        (!filters.per_terminal || row.per_terminal === filters.per_terminal) &&
        (!filters.per_resguardo || row.per_resguardo === filters.per_resguardo) &&
        (!filters.per_concomunitario || row.per_concomunitario === filters.per_concomunitario) &&
        (!filters.bar_barrio || row.bar_barrio === filters.bar_barrio) &&
        (!filters.bar_zona || row.bar_zona === filters.bar_zona) &&
        (!filters.bar_comuna || row.bar_comuna === filters.bar_comuna) &&
        (!filters.creadopor || row.creadopor === filters.creadopor)
    );

    // Paginación
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 50;
    const totalRows = filteredData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const paginatedData = filteredData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    React.useEffect(() => {
        setCurrentPage(1);
    }, [filters, datoscabeza]);
    async function exportarCSV() {
        setCargando(true);
        const FechaI = watch('FechaInicial').toLocaleDateString('en-CA')
        const FechaF = watch('FechaFinal').toLocaleDateString('en-CA')
        const url = `/caracterizacion/informes/familias?FechaInicio=${FechaI}&FechaFinal=${FechaF}&csv=${true}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            const csvData = result.map(row => ({
                per_idpersona: row.per_idpersona,
                per_nombre1: row.per_nombre1,
                per_nombre2: row.per_nombre2,
                per_apellido1: row.per_apellido1,
                per_apellido2: row.per_apellido2,
                integrantes: row.integrantes,
                tipo: row.tipo,
                per_anonaci: row.per_anonaci,
                per_mesnaci: row.per_mesnaci,
                per_dianaci: row.per_dianaci,
                gru_idcabezafamilia: row.gru_idcabezafamilia,
                cab_telefono1: row.cab_telefono1,
                cab_telefono2: row.cab_telefono2,
                par_parentesco: row.par_parentesco,
                dis_discapacidad: row.dis_discapacidad,
                per_sexo: row.per_sexo,
                per_gestante: row.per_gestante,
                per_edad: row.per_edad,
                min_minoria: row.min_minoria,
                per_terminal: row.per_terminal,
                per_resguardo: row.per_resguardo,
                per_concomunitario: row.per_concomunitario,
                per_asisteescuela: row.per_asisteescuela,
                per_asistiaescuela: row.per_asistiaescuela,
                estudiodescripcion: row.estudiodescripcion,
                tip_tipoauto: row.tip_tipoauto,
                per_ultimogrado: row.per_ultimogrado,
                cab_direccion: row.cab_direccion,
                cab_nodeclaracion: row.cab_nodeclaracion,
                bar_barrio: row.bar_barrio,
                bar_zona: row.bar_zona,
                bar_comuna: row.bar_comuna,
                per_fechacreacionsistema: row.per_fechacreacionsistema,
                est_estadocivil: row.est_estadocivil,
                per_ingresos: row.per_ingresos,
                creadopor: row.creadopor
            }));
            const blob = new Blob([Papa.unparse(csvData, { delimiter: '|' })], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'InformeHogares.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informe caracterizaci&oacute;n hogar</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Datos hogar</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativos/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-header' style={{display: 'flex', justifyContent: 'flex-end', textAlign: 'right',}}> 
                                    <ButtonsMenu data={filteredData} titulo={'Informe_hogar'} exportarCSV={exportarCSV}/>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <Container>
                                            <ButtonGroup aria-label="Basic example">
                                                <label htmlFor="FechaInicial">
                                                    <Controller
                                                        control={control}
                                                        name="FechaInicial"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                    id="FechaInicial"
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </label>
                                                {errors.FechaInicial && <p style={{color: 'red'}}>Fecha inicial</p>}
                                                <label htmlFor="FechaFinal">
                                                    <Controller
                                                        control={control}
                                                        name="FechaFinal"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block', height: 38 }}>
                                                                <DatePicker
                                                                    id="FechaFinal"
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.FechaFinal && <p style={{color: 'red'}}>Fecha final</p>}
                                                </label>
                                                <button
                                                    type="submit"
                                                    className="img-square elevation-1"
                                                    style={{
                                                        fontSize: '0.7rem',
                                                        padding: '2px 12px',
                                                        height: 38,
                                                        minWidth: '80px',
                                                        verticalAlign: 'middle',
                                                        border: '1px solid #6daff1ff',
                                                        borderRadius: 4,
                                                        background: '#abbdcfff',
                                                        display: 'inline-flex',
                                                        alignItems: 'center'
                                                    }}
                                                    data-tooltip-id='tooltiparriba'
                                                    data-tooltip-content="Consultar"
                                                >
                                                    <FaSearch /> Buscar
                                                </button>
                                            </ButtonGroup>
                                        </Container>
                                    </form>
                                </div>
                                {datoscabeza && datoscabeza.length > 0 && <div className="card-body table-responsive p-0">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0' }}>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Anterior
                                        </button>
                                        <span style={{ margin: '0 1rem' }}>
                                            Página {currentPage} de {totalPages}
                                        </span>
                                        <button
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Siguiente
                                        </button>
                                    </div>
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Acciones</th>
                                                <th>Identificación</th>
                                                <th>Primer Nombre</th>
                                                <th>Segundo Nombre</th>
                                                <th>Primer Apellido</th>
                                                <th>Segundo Apellido</th>
                                                <th>Integrantes</th>
                                                <th>Tipo de Familia</th>
                                                <th>Año Naci</th>
                                                <th>Mes Naci</th>
                                                <th>Dia Naci</th>
                                                <th>Iden. Cabeza</th>
                                                <th>Teléfono 1</th>
                                                <th>Teléfono 2</th>
                                                <th>Parentesco</th>
                                                <th>Discapacidad</th>
                                                <th>Sexo</th>
                                                <th>Gestante</th>
                                                <th>Edad</th>
                                                <th>Minoria</th>
                                                <th>Enf. Terminal</th>
                                                <th>Resguardo</th>
                                                <th>Con.Comunitario</th>
                                                <th>Asiste Escuela</th>
                                                <th>Asistia Escuela</th>
                                                <th>Tipo Estudio</th>
                                                <th>Autos de la Corte</th>
                                                <th>Último Grado</th>
                                                <th>Dirección</th>
                                                <th>No. Declaración</th>
                                                <th>Barrio</th>
                                                <th>Zona</th>
                                                <th>Comuna</th>
                                                <th>Fecha Creacion</th>
                                                <th>Estado Civil</th>
                                                <th>Ingresos</th>
                                                <th>Creado por</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.par_parentesco}
                                                        onChange={e => setFilters(f => ({ ...f, par_parentesco: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.par_parentesco).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.dis_discapacidad}
                                                        onChange={e => setFilters(f => ({ ...f, dis_discapacidad: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.dis_discapacidad).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_sexo}
                                                        onChange={e => setFilters(f => ({ ...f, per_sexo: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.per_sexo).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_gestante}
                                                        onChange={e => setFilters(f => ({ ...f, per_gestante: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.per_gestante).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.min_minoria}
                                                        onChange={e => setFilters(f => ({ ...f, min_minoria: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.min_minoria).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_terminal}
                                                        onChange={e => setFilters(f => ({ ...f, per_terminal: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.per_terminal).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_resguardo}
                                                        onChange={e => setFilters(f => ({ ...f, per_resguardo: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.per_resguardo).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.per_concomunitario}
                                                        onChange={e => setFilters(f => ({ ...f, per_concomunitario: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.per_concomunitario).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.bar_barrio}
                                                        onChange={e => setFilters(f => ({ ...f, bar_barrio: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.bar_barrio).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.bar_zona}
                                                        onChange={e => setFilters(f => ({ ...f, bar_zona: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.bar_zona).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th>
                                                    <select
                                                        value={filters.bar_comuna}
                                                        onChange={e => setFilters(f => ({ ...f, bar_comuna: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.bar_comuna).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        value={filters.creadopor}
                                                        onChange={e => setFilters(f => ({ ...f, creadopor: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...new Set(datoscabeza.map(row => row.creadopor).filter(Boolean))].map(val => (
                                                            <option key={val} value={val}>{val}</option>
                                                        ))}
                                                    </select>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((row, idx) => (
                                                <tr key={idx}>
                                                    <td>{verAtenciones(row, verAtencionesPersona)}</td>
                                                    <td>{row.per_idpersona}</td>
                                                    <td>{row.per_nombre1}</td>
                                                    <td>{row.per_nombre2}</td>
                                                    <td>{row.per_apellido1}</td>
                                                    <td>{row.per_apellido2}</td>
                                                    <td>{row.integrantes}</td>
                                                    <td>{row.tipo}</td>
                                                    <td>{row.per_anonaci}</td>
                                                    <td>{row.per_mesnaci}</td>
                                                    <td>{row.per_dianaci}</td>
                                                    <td>{row.gru_idcabezafamilia}</td>
                                                    <td>{row.cab_telefono1}</td>
                                                    <td>{row.cab_telefono2}</td>
                                                    <td>{row.par_parentesco}</td>
                                                    <td>{row.dis_discapacidad}</td>
                                                    <td>{row.per_sexo}</td>
                                                    <td>{row.per_gestante}</td>
                                                    <td>{row.per_edad}</td>
                                                    <td>{row.min_minoria}</td>
                                                    <td>{row.per_terminal}</td>
                                                    <td>{row.per_resguardo}</td>
                                                    <td>{row.per_concomunitario}</td>
                                                    <td>{row.per_asisteescuela}</td>
                                                    <td>{row.per_asistiaescuela}</td>
                                                    <td>{row.estudiodescripcion}</td>
                                                    <td>{row.tip_tipoauto}</td>
                                                    <td>{row.per_ultimogrado}</td>
                                                    <td>{row.cab_direccion}</td>
                                                    <td>{row.cab_nodeclaracion}</td>
                                                    <td>{row.bar_barrio}</td>
                                                    <td>{row.bar_zona}</td>
                                                    <td>{row.bar_comuna}</td>
                                                    <td>{row.per_fechacreacionsistema}</td>
                                                    <td>{row.est_estadocivil}</td>
                                                    <td>{row.per_ingresos}</td>
                                                    <td>{row.creadopor}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>

            


        </div>
    );
}